import { createAction, props } from "@ngrx/store";
import { DataType, Legislation } from "../models/lookups";
import { HttpErrorResponse } from "@angular/common/http";
import { CongressionalDistrict } from "../models/congressional-district";
import { ScorecardView } from "../models/views";
import { DataSnackBar } from "../models/snackbar-data";

export const getStates = createAction('Get States');
export const getStatesSuccess = createAction('Get States Success', props<{ states: DataType[] }>());
export const getStatesFailure = createAction('Get States Failure', props<{ error: HttpErrorResponse }>());

export const getLegislation = createAction('Get Legislation');
export const getLegislationSuccess = createAction('Get Legislation Success', props<{ Legislation: Legislation[] }>());
export const getLegislationFailure = createAction('Get Legislation Failure', props<{ error: HttpErrorResponse }>());

export const getVoteTypes = createAction('Get Vote Types');
export const getVoteTypesSuccess = createAction('Get Vote Types Success', props<{ voteTypes: DataType[] }>());
export const getVoteTypesFailure = createAction('Get Vote Types Failure', props<{ error: HttpErrorResponse }>());

export const getParties = createAction('Get Parties');
export const getPartiesSuccess = createAction('Get Parties Success', props<{ parties: DataType[] }>());
export const getPartiesFailure = createAction('Get Parties Failure', props<{ error: HttpErrorResponse }>());

export const getCongressmenDatatype = createAction('Get Congressmen Datatype');
export const getCongressmenDatatypeSuccess = createAction('Get Congressmen Datatype Success', props<{congressmenDisplayNames: DataType[]}>());
export const getCongressmenDatatypeFailure = createAction('Get Congressmen Datatype Failure', props<{ error: HttpErrorResponse}>());

export const getCongressionalDistrict = createAction('Get Congressional District', props<{ address?: string ; localUnion?: string }>());
export const getCongressionalDistrictSuccess = createAction('Get Congressional District Success', props<{ congressionalDistricts: CongressionalDistrict[]}>());
export const getCongressionalDistrictFailure = createAction('Get Congressional District Failure', props<{ error: HttpErrorResponse}>());

export const getScorecard = createAction('Get Scorecard', props<{ congressmanId?: number, stateId?: number, districtNumber?: number, localUnion?: number}>());
export const getScorecardSuccess = createAction('Get Scorecard Success', props<{ scorecards: ScorecardView[]}>());
export const getScorecardFailure = createAction('Get Scorecard Failure', props<{ error: HttpErrorResponse}>());

export const setCongressionalDistrict = createAction('Set Congressional District',props<{ stateId: number, districtNumber: number}>());
export const setSelectedCongressman = createAction('Set Selected Congressman', props<{ congressman: DataType}>());
export const setSelectedLocalUnion = createAction('Set Selected Local Union', props<{ selectedLocalUnion: number }>());
export const clearStore = createAction('Clear Store');
export const displayNotificationMessage = createAction('Display Notification Message', props<{ data: DataSnackBar }>());
